import { post } from "./index";
import {applicationName} from "../utils";
export const getNewsActivityById = (id, callBack) => {
    if(!id){
        callBack({});
        return;
    }
    let url = "/cm-sites-"+applicationName()+"/interview/getById";
    let time = new Date().getTime();
    window.$.ajax({
        type:"post",
        traditional: true,
        url: url,
        data:{'interviewId' : id, time},
        dataType:"json",
        success:function (result) {
            callBack(result);
        },
        error:function (e) {
            console.error(e);
            callBack({});
        }
    });
}

export const loadAttachmentFiles = (idsArray, callBack) => {
    if(!idsArray || idsArray.length === 0){
        callBack([]);
        return;
    }
    let url = "/cm-sites-"+applicationName()+"/interview/getAttachmentFiles";
    let time = new Date().getTime();
    window.$.ajax({
        type:"post",
        traditional: true,
        url: url,
        data:{'attachmentIds':idsArray,time},
        dataType:"json",
        success:function (result) {
            callBack(result);
        },
        error:function (e) {
            console.error(e);
            callBack([]);
        }
    });
}

/**加载任务资源*/
export const loadInterviewResource = (interviewId, callBack)=>
{
    let url = "/cm-sites-"+applicationName()+"/interview/getResource";
    let time = new Date().getTime();
    let params = {
        "interviewId" : interviewId,
        time
    };
    window.$.ajax({
        type:"post",
        url: url,
        data:params,
        dataType:"json",
        success:function (result) {
            callBack(result);
        },
        error:function (e) {
            console.error(e);
            callBack({});
        }
    });
}


/**将图片与采访任务绑定*/
export const pictureConvertParams = (picture, file, callBack) => {
    if(picture.interviewId > 0){
        let url = "/cm-sites-"+applicationName()+"/interview/saveInterviewPicture";
        let params = {};
        params.name = picture.storageFile.name;
        params.ext = picture.storageFile.suffix;
        params.path = picture.url;
        params.size = picture.storageFile.size?picture.storageFile.size:file.size;
        // params.allTime =result.storageFile.duration;
        params.imageWidth = picture.storageFile.width;
        params.imageHeight =  picture.storageFile.height;
        params.interviewId = picture.interviewId;
        params.type = 2;
        window.$.post(url, params, (res)=>{
            callBack(res);
        },"json");
    }
};

/**将视频与采访任务绑定*/
export function videoConvertParams(video, file, callBack)
{
    let url = "/cm-sites-"+applicationName()+"/interview/saveInterviewVideo";
    let params = {};
    params.name = video.storageFile.name;
    params.ext = video.storageFile.suffix;
    params.path = video.url;
    params.size = video.storageFile.size?video.storageFile.size:file.size;
    params.allTime = video.storageFile.duration;
    params.interviewId = video.interviewId;
    window.$.post(url, params, function (res) {
        callBack(res);
    },"json")
}

/**将美工附件与采访任务绑定*/
export function otherFileConvertParams(otherFile, file, callBack)
{
    let url = "/cm-sites-"+applicationName()+"/interview/saveInterviewAttachment";
    let params = {};
    params.name = otherFile.storageFile.name;
    params.ext = otherFile.storageFile.suffix;
    params.path = otherFile.url;
    params.size = otherFile.storageFile.size?otherFile.storageFile.size:file.size;
    params.allTime = otherFile.storageFile.duration;
    params.interviewId = otherFile.interviewId;
    window.$.post(url, params, function (res) {
        callBack(res);
    },"json")
}

export function delResource(interviewId, resourceid){
    if(resourceid){
        window.$.post("/cm-sites-"+applicationName()+"/interview/delResource", {interviewId:interviewId,resourceId:resourceid});
    }
}


/**领取新闻任务*/
export const takeTask = (interviewId)=> new Promise((resolve, reject) => {
    let url = "/cm-sites-"+applicationName()+"/interview/takeTask";
    let params = {
        "interviewId" : interviewId
    };
    window.$.ajax({
        type:"post",
        url: url,
        data:params,
        dataType:"json",
        success:function (result) {
            resolve(result);
        },
        error:function (e) {
            console.error(e);
            reject({});
        }
    });
})

/**获取记者列表*/
export const getReporterList = (start,size,interviewId,searchStr, statistics,reportType,startDate,endDate,checkedAccount,prop)=> new Promise((resolve, reject) => {
    let url = "/cm-sites-"+applicationName()+"/user/reporterList";
    let time = new Date().getTime();
    let params = {
        start,size,searchStr, statistics,reportType,startDate,endDate,checkedAccount,interviewId,prop,time
    };
    window.$.ajax({
        type:"post",
        url: url,
        data:params,
        dataType:"json",
        success:function (result) {
            resolve(result);
        },
        error:function (e) {
            console.error(e);
            reject({});
        }
    });
})

//修改任务状态
export const changeTaskStatus=(param,callBack)=>{
    post("/cm-sites-"+applicationName() +"/interview/changeStatus",param,callBack);
}